import React from "react";
import "../../../../../Assets/Styles/ProfileMenu.scss";

const ProfileMenu = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const shortenText = (text) => {
    if (text.length < 22) {
      return text;
    } else {
      let Short = text.slice(0, 22) + " ...";
      return (
        <>
          {Short}
          <p className="popup-text">{text}</p>
        </>
      );
    }
  };

  const handleEditProfile = () => {
    props.Close();
    if (window.location.pathname === "/home/editProfile") {
      document.getElementById("pref-nav-item").click();
    } else {
      document.getElementById("edit-profile-nav-link").click();
    }
  };

  const handleEditNotificationsClick = () => {
    props.Close();
    window.localStorage.setItem("IsEditNotifications", 1);
    if (window.location.pathname === "/home/editProfile") {
      document.getElementById("notif-nav-item").click();
    } else {
      setTimeout(() => {
        document.getElementById("edit-profile-nav-link").click();
      }, 100);
    }
  };

  return (
    <>
      <div className="profile-menu-outline" onClick={() => props.Close()}></div>
      <div className="profile-menu">
        <section className="profile-menu-head">
          <>
            {props.UserInfo.imageThumbnailUrl !== null ? (
              <img
                src={props.UserInfo.imageThumbnailUrl}
                className="user-image avatar"
              />
            ) : (
              <span
                style={{
                  backgroundColor: props.UserInfo.backgroundColorCode,
                  color: props.UserInfo.textColorCode,
                }}
                className="avatar avatar-placeholder"
              >
                {props.UserInfo.firstName.slice(0, 1).toUpperCase() +
                  props.UserInfo.lastName.slice(0, 1).toUpperCase()}
              </span>
            )}
          </>
          <section className="user-info">
            <h3>{props.UserInfo.firstName + " " + props.UserInfo.lastName}</h3>
            <p>{props.EmployeePos ? shortenText(props.EmployeePos) : ""}</p>
          </section>
        </section>
        <div className="profile-menu-actions">
          <section className="action-item" onClick={() => handleEditProfile()}>
            <i className="feather-user"></i>
            <p>{translateText("edit_profile")}</p>
          </section>
          <section
            className="action-item"
            onClick={() => handleEditNotificationsClick()}
          >
            <i className="feather-settings"></i>
            <p>{translateText("edit_notifications")}</p>
          </section>
          <section
            className="action-item"
            onClick={() => {
              document.getElementById("back-to-home-navlink").click();
              props.Close();
              setTimeout(() => {
                document.getElementById("edit-avatar-image-trigger").click();
              }, 800);
            }}
          >
            <i className="feather-camera"></i>
            <p>{translateText("edit_photo")}</p>
          </section>
          <section
            className="action-item"
            onClick={() => {
              props.Close();
              props.UpdateWalkthrough(false);
            }}
          >
            <i className="feather-play-circle"></i>
            <p>{translateText("reset_walkthrough")}</p>
          </section>
          <section
            className="action-item logout-action"
            onClick={() => {
              props.Close();
              document.getElementById("logout-trigger").click();
            }}
          >
            <i className="feather-log-out"></i>
            <p>{translateText("logout")}</p>
          </section>
        </div>
      </div>
    </>
  );
};

export default ProfileMenu;
